import RestService from './restService';

function useRest(authOverrideConfig) {
  const restInstance = new RestService(authOverrideConfig);

  return {
    restInstance
  };
}

const { restInstance } = useRest({});

export default restInstance;
